import React from 'react';

export interface CustomIconProps {
  filled?: boolean;
  width?: string;
}

const ShareIcon: React.FC<CustomIconProps> = ({ width }) => {
  return (
    <svg
      width={width ?? '20'}
      height={width ?? '20'}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.33341 15.8327H16.6667V11.666H18.3334V16.666C18.3334 16.887 18.2456 17.099 18.0893 17.2553C17.9331 17.4116 17.7211 17.4993 17.5001 17.4993H2.50008C2.27907 17.4993 2.06711 17.4116 1.91083 17.2553C1.75455 17.099 1.66675 16.887 1.66675 16.666V11.666H3.33341V15.8327Z'
        fill='white'
      />
      <path
        d='M5.87438 6.89768L9.16604 3.60602L9.16605 12.916L10.8327 12.916L10.8327 3.60601L14.1244 6.89768L15.3027 5.71935L9.99938 0.416015L4.69604 5.71935L5.87438 6.89768Z'
        fill='white'
      />
    </svg>
  );
};

export default ShareIcon;
